module.exports = __webpack_public_path__ + "img/active-b.89ae7a04.png";